import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarGoogle } from '../../models/doctor-model';
import { LabelService } from '../../services/label.service';

@Component({
  selector: 'app-calendars-info-panel',
  standalone: false,
  templateUrl: './calendars-info-panel.component.html',
  styleUrl: './calendars-info-panel.component.scss',
})
export class CalendarsInfoPanelComponent {
  @Input() calendars: CalendarGoogle[] = [];
  @Output() close = new EventEmitter<void>();

  constructor(public labelService: LabelService) {}

  onClose() {
    this.close.emit();
  }
}
